define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const _ = require('underscore');
    const core = require('core');
    const i18n = require('i18n');
    const user = require('user');
    const server = require('server');
    const validationHelpers = require('modules/user/user.validation.helpers');
    const getDynamicTagValue = require('../../../util/swiss-theme/dynamicTag.value.util');

    var userValidationConfig = require('modules/user/user.validation.config');
    module.exports = function() {
        var config = userValidationConfig();
        var passRe = /^(?=.*[0-9])(?=.*[._$#+%&!?@-])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z._$#+%&!?@-]+$/;

        function datePickerPrepareData($inputs) {
            var dateStringFromInput = $inputs[0].value;
            var dateArr = dateStringFromInput.split('.');
            var formattedDateArr = dateArr.map(function(el) {
                return Number(el.trim());
            });

            var dateParts = {
                'day': formattedDateArr[0],
                'month': formattedDateArr[1],
                'year': formattedDateArr[2]
            };

            var areAllInputsFilled = _.values(dateParts).every(function(datePart) {
                return !_.isNaN(datePart);
            });

            return {
                date: dateParts,
                areAllInputsFilled: areAllInputsFilled
            };
        }

        var validatePhoneNumber = function(isRequired, $inputs) {
            var phone = $inputs.map(_.property('value')).join('').trim();
            var area = _.find($inputs, function(input) {
                return input.name === 'cellphone_area';
            });
            var areaValue;

            if (area) {
                areaValue = area.value.trim();
                if (areaValue.length < 1 || areaValue.length > 4) {
                    this.message = i18n.t('playtech.mobile.system.user.tooltip.area.length');
                    return false;
                }
            }

            if (isRequired && !phone) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.phoneWithArea.required');
                return false;
            }

            if (isRequired && (phone.length < 10 || phone.length > 15)) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.phoneWithArea.length');
                return false;
            }

            return /^\+[0-9]+$/.test(phone);
        };

        var datePickerValidateFn = function($inputs) {
            var data = datePickerPrepareData($inputs);

            return data.areAllInputsFilled;
        };

        var adultDateCheck = function(data) {
            var minAge = 18;
            var adultDate = new Date(data.date.year + minAge, data.date.month - 1, data.date.day);

            return adultDate <= new Date();
        };

        var dateOfBirthValidateFn = function($inputs) {
            const data = datePickerPrepareData($inputs);
            const minDay = 1;
            const maxDay = 31;
            const maxMonth = 12;
            const maxAge = 120;
            const invalidYear = new Date().getFullYear() - data.date.year > maxAge;

            if (!data.areAllInputsFilled) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.birthdate.required');
                return false;
            }
            if (data.date.day > maxDay && data.date.month > maxMonth || (data.date.day || data.date.month) < minDay) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.birthdate.dayAndMonth');
                return false;
            }
            if (data.date.day > maxDay || data.date.day < minDay) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.birthdate.day');
                return false;
            }
            if (data.date.month > maxMonth || data.date.month < minDay) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.birthdate.month');
                return false;
            }
            if (invalidYear) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.birthdate.year');
                return false;
            }

            return adultDateCheck(data);
        };

        const isZeroAndIsInput = function(value, isInputType) {
            var isInvalidValue = !value && value !== 0;
            var isZeroValue = value === 0 && isInputType;
            return !(isInvalidValue || isZeroValue);
        };

        const isZeroAndIsDropdown = function(value, isInputType) {
            return value === 0 && !isInputType;
        };

        const isFitLimitAmount = {
            'session': function(data, isInputType) {
                var value = data.session;
                // deposit limit has editable dropdown type
                // 'isInputType' param use for loss/bet limits
                var isDepositLimit = _.isUndefined(isInputType);

                if (!isDepositLimit && !isZeroAndIsInput(value, isInputType)) {
                    return false;
                }

                if (!isDepositLimit && isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }

                if (data.day && data.day < value) {
                    return false;
                }

                if (data.week && data.week < value) {
                    return false;
                }

                if (data.month && data.month < value) {
                    return false;
                }

                return true;
            },

            'day': function(data, isInputType) {
                var value = data.day;

                if (!isZeroAndIsInput(value, isInputType)) {
                    return false;
                }

                if (isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }

                if (data.week && data.week < value) {
                    return false;
                }

                if (data.month && data.month < value) {
                    return false;
                }

                if (data.session && data.session > value) {
                    return false;
                }

                return true;
            },

            'week': function(data, isInputType) {
                var value = data.week;

                if (!isZeroAndIsInput(value, isInputType)) {
                    return false;
                }

                if (isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }

                if (data.day && data.day > value) {
                    return false;
                }

                if (data.month && data.month < value) {
                    return false;
                }

                if (data.session && data.session > value) {
                    return false;
                }

                return true;
            },

            'month': function(data, isInputType) {
                var value = data.month;

                if (!isZeroAndIsInput(value, isInputType)) {
                    return false;
                }

                if (isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }

                if (data.day && data.day > value) {
                    return false;
                }

                if (data.week && data.week > value) {
                    return false;
                }

                if (data.session && data.session > value) {
                    return false;
                }

                return true;
            }
        };

        config.registerEmail.ajax.fn = function($inputs, config, form, dfd) {
            var token = user.get('userAvailabilityVerificationToken');
            var val = $inputs.val();
            var INTERNAL_EMAIL = 'test@playtech.com';
            var isInternalEmail = val === INTERNAL_EMAIL;

            if (!isInternalEmail) {
                Playtech.API.server.checkIfUsernameIsAvailable({
                    email: $inputs.val(),
                    casinoName: Playtech.Variables.casinoName,
                    ...token && { token }
                }).then(function(data) {
                    const { emailAvailable } = data;
                    if (emailAvailable === 'available' || emailAvailable === 'unknown') {
                        dfd.resolve(data);
                    } else {
                        dfd.reject({
                            message: [
                                i18n.t('playtech.mobile.system.user.tooltip.email.occupied')
                            ].filter(Boolean).join(' ')
                        });

                        let parentElement = document.querySelector('.form__fieldset');
                        let childElements = parentElement.querySelectorAll('fieldset');
                        const emailField = parentElement.querySelector('.fieldset');

                        window.document.querySelector('.btn_type_success.fn-next-btn').classList.add('hidden');
                        window.document.querySelector('.btn_type_success.fn-login-from-reg').classList.remove('hidden');
                        window.document.querySelector('.fn-go-to-reg-steps').classList.remove('hidden');

                        const emailInput = document.querySelector('input#domains');
                        const email = emailInput.value;
                        window.localStorage.setItem('userEmailFromReg', email);

                        if (emailField) {
                            emailField?.querySelector('input')?.classList?.add('disabled-email-input');
                            const invalidEmailElement = parentElement.querySelector('.email.invalid');
                            const labelAbove = parentElement.querySelector('.floating-label.label-above');
                            // Check if the invalid email element exists
                            if (invalidEmailElement && labelAbove) {
                                invalidEmailElement?.classList?.add('hide-after-close-icon');
                            }
                        }

                        for (let i = 0; i < childElements.length; i++) {
                            childElements[i]?.querySelectorAll('input')?.forEach(function(input) {
                                input.blur();
                            });
                            // Set display: none to hide the child element
                            childElements[i].style.display = 'none';
                        }
                    }
                }).catch(function(error) {
                    const { data: { errorCode, errorMessage } = {} } = error.response || {};

                    switch (errorCode) {
                        case -1: {
                            dfd.resolve(error.response);
                            break;
                        }
                        case 301: {
                            core.trigger('recaptcha:show', {
                                input: $inputs[0],
                                renderOptions: {
                                    operation: 'checkUsernameAvailability',
                                    onValidate: (verificationToken) => {
                                        user.set('userAvailabilityVerificationToken', verificationToken);
                                        config.registerEmail.ajax.fn($inputs, config, form, dfd);
                                    },
                                    onError: dfd.reject
                                }
                            });
                            break;
                        }
                        default: {
                            dfd.reject({ message: errorMessage });
                        }
                    }
                });
            } else {
                dfd.resolve();
            }

            return dfd;
        };

        return _.extend({}, config, {
            restrictedCity: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.city.required')
                },
                fn: {
                    fn: function($inputs) {
                        const restrictedCity = getDynamicTagValue('RESTRICTEDCITY');

                        if (restrictedCity && restrictedCity.split(',')) {
                            const cityArray = restrictedCity.toLocaleLowerCase().split(',');
                            const result = cityArray.filter(el=> el === $inputs.val().toLowerCase());

                            if (result.length) {
                                this.message = i18n.t('playtech.mobile.system.user.tooltip.city.excluded');

                                return false;
                            }

                            return true;
                        }
                    }
                }
            },
            restrictedZip: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.zip.required')
                },
                fn: {
                    fn: function($inputs) {
                        const restrictedZip = getDynamicTagValue('RESTRICTEDZIP');

                        if (restrictedZip && restrictedZip.split(',')) {
                            const cityArray = restrictedZip.toLocaleLowerCase().split(',');
                            const result = cityArray.filter(el=> el === $inputs.val().toLowerCase());

                            if (result.length) {
                                this.message = i18n.t('playtech.mobile.system.user.tooltip.zip.restricted');

                                return false;
                            }
                        }

                        return true;
                    }
                }
            },
            password: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.password.length')
                },
                length: {
                    min: 8,
                    max: 20,
                    message: i18n.t('playtech.mobile.system.user.error.input.password.maxlength')
                },
                fn: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.password.required'),
                    fn: function($inputs) {
                        if (!passRe.test($inputs.val())) {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.password.regexp');
                            return false;
                        }

                        return true;
                    }
                }
            },
            updateDetailsZip: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.zip.required')
                },
                length: {
                    min: 4,
                    max: 4,
                    message: i18n.t('playtech.mobile.system.user.tooltip.zip.length')
                },
                regexp: {
                    regexp: /^(?!(948[5-9]|949[0-8]|6911|8238)$)[0-9]{4}$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.zip.excluded')
                }
            },
            changePassword: {
                required: {
                    message: ''
                },
                length: {
                    min: 8,
                    max: 20,
                    message: ''
                },
                regexp: {
                    regexp: passRe,
                    message: ''
                },
                fn: {
                    message: '',
                    fn: function($inputs, config, form) {
                        const password = form.$el.find('input[name="password"]').val();
                        const userName = user.attributes.userName;
                        const firstname = user.attributes.userDetails.firstName;
                        const lastname = user.attributes.userDetails.lastName;

                        const checkPassInvalid = function(field) {
                            return field && password.search(new RegExp(field, 'i')) > -1;
                        };

                        this.message = '';

                        // password shouldn't contain  user first/last name or username
                        return ![firstname, lastname, userName].some(checkPassInvalid);
                    }
                }
            },
            buildingNumber: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.houseNumber.required')
                },
                length: {
                    min: 1,
                    max: 4,
                    message: i18n.t('playtech.mobile.system.user.tooltip.address3.length')
                },
                regexp: {
                    regexp: /^[0-9]*[a-zA-Z]?$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.houseNumber.regexp')
                }
            },
            city: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.city.required')
                },
                length: {
                    min: 3,
                    max: 30,
                    message: i18n.t('playtech.mobile.system.user.tooltip.city.length')
                },
                regexp: {
                    regexp: /^[A-Za-zäÄüUõöÖéÉèÈêÊëËàÀâÂñÑáÁóÓúÚíÍß'\-]+(?: [A-Za-zäÄüUõöÖéÉèÈêÊëËàÀâÂñÑáÁóÓúÚíÍß'\-]+)*$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.city.regexp')
                }
            },
            streetName: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.streetName.required')
                },
                length: {
                    min: 3,
                    max: 30,
                    message: i18n.t('playtech.mobile.system.user.tooltip.address3.length')
                },
                regexp: {
                    regexp: /^[A-Za-zäÄüUõöÖéÉèÈêÊëËàÀâÂñÑáÁóÓúÚíÍß'\-]+(?: [A-Za-zäÄüUõöÖéÉèÈêÊëËàÀâÂñÑáÁóÓúÚíÍß'\-]+)*$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.address.regexp')
                }
            },
            lossLimit: {
                fn: {
                    fn: function($inputs, config, form) {
                        const options = form.options.data;
                        const lossConfig = options.lossLimitsConfig;
                        const data = _.mapObject(form.data(), Number);
                        const fieldName = $inputs[0].name;
                        const value = Number($inputs.val());
                        const viewFieldTypesMatchStr = 'dayloss|weekloss|monthloss|sessionloss';
                        const validationFieldTypesMatchStr = 'day|week|month|session';

                        // can't be moved to regexp because of Reg builder `internal` type validation supports only fn and ajax
                        if (!validationHelpers.moneyRegex.test($inputs.val())) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.amount');

                            return false;
                        }

                        // check another fields
                        let fields = form.$el.find('[data-validation-type=lossLimit]');

                        if (!fields.length) {
                            fields = form.$el.find('.fn-loss-limit-generic');
                        }

                        if (!form.validationInProgress) {
                            form.validationInProgress = true;

                            _.each(fields, function(field) {
                                form.validateField($(field), options);
                            });

                            form.validationInProgress = false;
                        }
                        // format to {day:, week:, month:} for easy validation
                        const formattedData = _.keys(data).reduce(function(memo, limitName) {
                            const matched = limitName.match(viewFieldTypesMatchStr);

                            if (matched) {
                                memo[matched[0].split('loss')[0]] = data[limitName];
                            }

                            return memo;
                        }, {});

                        const isAllLimitsAreEmpty = function(periods) {
                            return _.every(_.pairs(periods), function(pair) {
                                return pair[1] === 0;
                            });
                        };

                        if (lossConfig.mandatory && isAllLimitsAreEmpty(formattedData)) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.limits.lossLimitRequired');
                            return false;
                        }

                        if (lossConfig.mandatory && value === 0) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.limits.alllossLimitsRequired');
                            return false;
                        }

                        if (form.options.isRegistrationForm) {
                            // check daily <= weekly <= monthly
                            const currentLimitName = fieldName.match(validationFieldTypesMatchStr)[0];
                            if (!validationHelpers.isFitLimitAmount[currentLimitName](formattedData)) {
                                this.message =
                                    i18n.t('playtech.mobile.system.tooltip.limits.error.' + currentLimitName);
                                return false;
                            }
                        }

                        if (lossConfig.predefinedType === 'enabled') {
                            if (lossConfig.noLimitsAllowed && value === Number(lossConfig.unlimitedAmount) || value
                                === 0) {
                                return true;
                            }

                            const allowedLimits = lossConfig.predefinedLimits.map(Number);

                            if (lossConfig.noLimitsAllowed) {
                                allowedLimits.pop();
                            }

                            const min = Math.min.apply(null, allowedLimits);
                            const max = Math.max.apply(null, allowedLimits);

                            if (value < min || value > max) {
                                const tkEnabled = 'playtech.mobile.system.tooltip.enabledType' + (lossConfig.mandatory
                                    ? ''
                                    : '.empty');
                                this.message = i18n.t(tkEnabled, min, max);

                                return false;
                            }
                        }

                        if (!lossConfig.noLimitsAllowed && value === Number(lossConfig.unlimitedAmount)) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.amount');
                            return false;
                        }

                        return true;
                    }
                }
            },
            depositLimit: {
                regexp: {
                    regexp: /^[0-9]+$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.limit.regexp')
                },
                fn: {
                    fn: function($inputs, config, form) {
                        var options = form.options.data;
                        var data = _.mapObject(form.data(), Number);
                        var fieldName = $inputs[0].name;
                        var value = Number($inputs.val());
                        var viewFieldTypesMatchStr = 'daydeposit|weekdeposit|monthdeposit';
                        var validationFieldTypesMatchStr = 'day|week|month';
                        var isQuestionnairePopup = options.type === 'questionnaire';

                        // check another fields
                        var fields = form.$el.find('[data-validation-type=depositLimit]');
                        if (!fields.length) {
                            fields = form.$el.find('.fn-deposit-limit-generic');
                        }

                        if (!form.validationInProgress) {
                            form.validationInProgress = true;

                            _.each(fields, function(field) {
                                form.validateField($(field), options);
                            });

                            form.validationInProgress = false;
                        }
                        // format to {day:, week:, month:} for easy validation
                        var formattedData = _.keys(data).reduce(function(memo, limitName) {
                            var matched = limitName.match(viewFieldTypesMatchStr);

                            if (matched) {
                                memo[matched[0].split('deposit')[0]] = data[limitName];
                            }

                            return memo;
                        }, {});

                        // check playerMustSetLimits & allPeriodsRequired & noLimitsAllowed
                        var isAllLimitsAreEmpty = function(periods) {
                            return _.every(_.pairs(periods), function(pair) {
                                return pair[1] === 0;
                            });
                        };

                        if (options.playerMustSetLimits) {
                            if (options.allPeriodsRequired && value === 0) {
                                this.message = i18n.t('playtech.mobile.system.tooltip.limits.allRequired');
                                return false;
                            }

                            if (!options.allPeriodsRequired && isAllLimitsAreEmpty(formattedData)) {
                                this.message = i18n.t('playtech.mobile.system.tooltip.limits.oneRequired');
                                return false;
                            }
                        }

                        if (!options.allPeriodsRequired && value === 0) {
                            return true;
                        }

                        // check daily <= weekly <= monthly
                        var currentLimitName = fieldName.match(validationFieldTypesMatchStr)[0];

                        if (!isFitLimitAmount[currentLimitName](formattedData)) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.limits.error.' + currentLimitName);
                            return false;
                        }

                        // check if predefinedType = 'enabled'
                        if (options && options.predefinedType === 'enabled' && !isQuestionnairePopup) {
                            // skip range validation for 'Unlimited' and '0'
                            if (options.noLimitsAllowed && value === Number(options.UNLIMITED_AMOUNT) || value === 0) {
                                return true;
                            }

                            var allowedLimits = options.allowedLimits.map(Number);
                            var isEmptyAllowed = options.playerMustSetLimits && !options.allPeriodsRequired;

                            if (options.noLimitsAllowed) {
                                allowedLimits.pop();
                            }

                            var min = Math.min.apply(null, allowedLimits);
                            var max = Math.max.apply(null, allowedLimits);

                            if (value < min || value > max) {
                                var tkEnabled = 'playtech.mobile.system.tooltip.enabledType' + (isEmptyAllowed
                                    ? '.empty'
                                    : '');
                                this.message = i18n.t(tkEnabled, min, max);
                                return false;
                            }
                        }
                        // check for Unlimited if not permitted
                        if (!options.noLimitsAllowed && value === Number(options.UNLIMITED_AMOUNT)) {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.limit.regexp');
                            return false;
                        }

                        return true;
                    }
                }
            },
            limit: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.limit.required')
                },
                regexp: {
                    regexp: /^[0-9]+$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.limit.regexp')
                },
                fn: {
                    fn: function($inputs, config, form, dfd, event, options) {
                        // check another fields
                        var fields = form.$el.find('[data-validation-type=limit]');

                        if (!fields.length) {
                            fields = form.$el.find('.fn-deposit-limit-generic');
                        }

                        if (form.validationInProgress !== true) {
                            form.validationInProgress = true;

                            _.each(fields, function(field) {
                                form.validateField($(field), options);
                            });

                            form.validationInProgress = false;
                        }

                        // check current field
                        var fieldTypesMatchedStr = 'session|day|week|month';
                        var isInputType = $inputs[0].tagName === 'INPUT';
                        var parsedData = _.chain(form.data())
                            .omit('betlimitaction', 'losslimitaction')
                            .mapObject(Number)
                            .value();
                        var changedField = $inputs[0].name.match(fieldTypesMatchedStr)[0];

                        // collect all value from form to correct object
                        // structured inputted form data to object {session: 0, ..., week: 1}
                        // check daily <= weekly <= monthly
                        var formattedData = _.keys(parsedData).reduce(function(memo, limitName) {
                            var matched = limitName.match(fieldTypesMatchedStr)[0];
                            memo[matched] = parsedData[limitName];
                            return memo;
                        }, {});

                        if (!isFitLimitAmount[changedField](formattedData, isInputType)) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.limits.error.' + changedField);
                            return false;
                        }

                        return true;
                    }
                }
            },
            oldPassword: {
                required: true
            },
            dateOfBirth: {
                fn: {
                    fn: function($inputs) {
                        return dateOfBirthValidateFn.call(this, $inputs);
                    },
                    message: i18n.t('playtech.mobile.system.user.tooltip.birthdate.fn')
                },
            },
            secondPhone: {
                fn:  {
                    fn: function($inputs) {
                        return validatePhoneNumber.call(this, false, $inputs);
                    },
                    message: i18n.t('playtech.mobile.system.user.tooltip.phoneWithArea.fn')
                }
            },
            userName: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.userName.required')
                },
                length: {
                    min: 5,
                    max: 16,
                    message: i18n.t('playtech.mobile.system.user.tooltip.userName.length')
                },
                regexp: {
                    regexp: /^[A-Za-z0-9\-\.\@_\s]+$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.userName.regexp')
                },
                ajax: {
                    fn: (function() {
                        let prevValue; //  used for reduce server request

                        return function ajax($inputs, config, form, dfd) {
                            const { value } = $inputs[0];
                            const token = user.get('userAvailabilityVerificationToken');
                            const fromLoginForm = $inputs[0]?.classList?.contains('fn-user-name');

                            if (value === prevValue || fromLoginForm) {
                                return dfd.resolve();
                            }

                            $inputs
                                .addClass('progress__username')
                                .attr('disabled', 'disabled');

                            Playtech.API.server.checkIfUsernameIsAvailable({
                                userName: value,
                                casinoName: Playtech.Variables.casinoName,
                                ...token && { token }
                            })
                                .then(function(data) {
                                    const { usernameAvailable, suggestions = [] } = data;
                                    if (usernameAvailable) {
                                        prevValue = value;
                                        dfd.resolve(data);
                                    } else {
                                        dfd.reject({
                                            message: [
                                                i18n.t('playtech.mobile.system.user.tooltip.username.occupied'),
                                                suggestions.map(s => `<a class="fn-suggestion">${s}</a>`).join(' ')
                                            ].filter(Boolean).join(' ')
                                        });
                                    }
                                })
                                .catch(function(error) {
                                    const { data: { errorCode, errorMessage } = {} } = error.response || {};

                                    switch (errorCode) {
                                        case -1: {
                                            dfd.resolve(error.response);
                                            break;
                                        }
                                        case 301: {
                                            core.trigger('recaptcha:show', {
                                                input: $inputs[0],
                                                renderOptions: {
                                                    operation: 'checkUsernameAvailability',
                                                    onValidate: (verificationToken) => {
                                                        user.set('userAvailabilityVerificationToken', verificationToken);
                                                        ajax($inputs, config, form, dfd);
                                                    },
                                                    onError: dfd.reject
                                                }
                                            });
                                            break;
                                        }
                                        default: {
                                            dfd.reject({ message: errorMessage });
                                        }
                                    }
                                })
                                .finally(({ data: { errorCode } = {} } = {}) => {
                                    errorCode !== 301 && $inputs.removeClass('progress__username').removeAttr('disabled');
                                });

                            return dfd;
                        };
                    })()
                }
            },
        });
    };
});
